'use strict';

// From http://stackoverflow.com/a/19846473/650722
SwaggerEditor.directive('stopEvent', function() {
  return {
    restrict: 'A',
    link: function(scope, element) {
      element.bind('click', function(e) {
        e.stopPropagation();
      });
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/directives/stop-event.js
// module id = 430
// module chunks = 0